// PLUGINS IMPORTS //
import React from 'react'
import styled from 'styled-components/macro'

// COMPONENTS IMPORTS //
import Body from './Body/Body'
import Video from 'Content/Shared/Components/Elements/Video/Video'
import { memoComparison } from 'Content/Shared/Helpers/Functions/Functions'

// EXTRA IMPORTS //
import { iPadProResolution } from 'Content/Shared/Styles/Theme'

// @ts-ignore
import LiquidSwipe from 'Assets/Videos/LiquidSwipe.mp4'
// @ts-ignore
import MonstersCarousel from 'Assets/Videos/MonstersCarousel.mp4'
// @ts-ignore
import EarphonesSlider from 'Assets/Videos/EarphonesSlider.mp4'
// @ts-ignore
import InvertedSlider from 'Assets/Videos/InvertedSlider.mp4'
// @ts-ignore
import MaskedSelector from 'Assets/Videos/MaskedSelector.mp4'
// @ts-ignore
import EventsCarousel from 'Assets/Videos/EventsCarousel.mp4'
// @ts-ignore
import SocialScroll from 'Assets/Videos/SocialScroll.mp4'
// @ts-ignore
import DualCarousel from 'Assets/Videos/DualCarousel.mp4'
// @ts-ignore
import CoffeeSlider from 'Assets/Videos/CoffeeSlider.mov'
// @ts-ignore
import FuturisticGraph from 'Assets/Videos/FuturisticGraph.mov'
// @ts-ignore
import Slider from 'Assets/Videos/Slider.mov'
// @ts-ignore
import CandleGraph from 'Assets/Videos/CandleGraph.mov'
// @ts-ignore
import DragDrop from 'Assets/Videos/DragDrop.mov'

// REDUX
import { ExpositionType } from 'Redux/Types/ExpositionsTypes'

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  exposition: ExpositionType
  isRight: boolean
}

const Videos = {
  LiquidSwipe,
  EarphonesSlider,
  MonstersCarousel,
  InvertedSlider,
  MaskedSelector,
  EventsCarousel,
  SocialScroll,
  DualCarousel,
  CoffeeSlider,
  FuturisticGraph,
  Slider,
  CandleGraph,
  DragDrop,
} as any

const ExpositionItem: React.FC<PropsType> = (props) => {
  const { title } = props.exposition
  const video = Videos[title.replace(/\s/g, '')]

  return (
    <Wrapper isRight={props.isRight}>
      {!props.isRight && <Video video={video} />}
      <Body exposition={props.exposition} isRight={props.isRight} />
      {props.isRight && <Video video={video} />}
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const MARGIN_HORIZONTAL = 165
const Wrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media (min-width: ${1030}px) {
    justify-content: ${({ isRight }: { isRight: boolean }) =>
      isRight ? 'flex-end' : 'flex-start'};
    margin-right: ${({ isRight }: { isRight: boolean }) =>
      isRight ? MARGIN_HORIZONTAL : 0}px;
    margin-left: ${({ isRight }: { isRight: boolean }) =>
      isRight ? MARGIN_HORIZONTAL : 0}px;
    margin-top: -195px;
    width: 100%;
  }

  @media (max-width: ${iPadProResolution}px) {
    flex-direction: ${({ isRight }: { isRight: boolean }) =>
      isRight ? 'column' : 'column-reverse'};
    margin-bottom: 60px;

    video {
      margin-top: 30px;
      height: 480px;
    }
  }
`

export default React.memo(ExpositionItem, memoComparison)
